import React, {FC, Fragment} from 'react'
import {Form, Input, Row, Col} from 'antd';
import { rules } from '@/components/Validation/Form.validate';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
};

const SendBackActionForm: FC<any> = props => {
    const { TextArea } = Input;
    const { formRef, initialValues, confirmText, fileList, setFileList, handleChange, handleSubmit, handleSubmitFailed } = props;

    return (
        <Fragment>
            <div className="form-page-content form-page-content-workflow-transition">
                <Form
                    {...formItemLayout}
                    form={formRef}
                    name="workflowTransitionForm"
                    scrollToFirstError={true}
                    initialValues={initialValues}
                    onValuesChange={handleChange}
                    onFinish={handleSubmit}
                    onFinishFailed={handleSubmitFailed}
                >
                    <Row>
                        <Col span={24}>
                            {confirmText && (
                              <div className="form-item-row">
                                  <h3>{confirmText}</h3>
                              </div>
                            )}
                            <div className="form-item-row">
                                <Form.Item
                                    label="Comment"
                                    name="comment"
                                    rules={rules.required}
                                >
                                    <TextArea
                                        autoSize={{ minRows: 5, maxRows: 8 }}
                                    />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        </Fragment>
    );
}
export default React.memo(SendBackActionForm);
